"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hex2rgb = hex2rgb;

/**
 * Converts HEX to RGB.
 * @param hex 6 digit HEX.
 */
function hex2rgb(hex) {
  var hexInt = parseInt(hex.slice(1), 16);
  var r = hexInt >> 16 & 255;
  var g = hexInt >> 8 & 255;
  var b = hexInt & 255;
  return {
    r: r,
    g: g,
    b: b
  };
}